<template>
  <v-row
    :id="contentType.uuid"
    no-gutters
    class="d-flex contentTypeList grab"
    :draggable="true"
    @dragstart="dragStart($event, contentType)"
    @dragover.prevent="dragOver($event, contentType)"
    @dragleave="dragLeave($event, contentType)"
    @drop="dropItem($event, contentType)"
    @dblclick="openResoursePage(contentType)"
  >
    <v-col cols="2" class="d-flex align-center full-height">
      <v-avatar size="24" color="third" class="ml-2">
        <v-icon v-if="contentTypeProps.icon" color="white">
          {{ contentTypeProps.icon }}
        </v-icon>
        <span v-else class="white--text">{{ contentTypeProps.text[0] }}</span>
      </v-avatar>
    </v-col>
    <v-col :class="`ml-2 d-flex align-center ${cols}`">
      <v-tooltip right>
        <template #activator="{ on, attrs }">
          <span
            v-if="!search"
            v-bind="attrs"
            class="font-size-14"
            v-on="on"
          >{{ label(contentTypeProps.text, 15) }}</span>
          <span
            v-else
            v-bind="attrs"
            v-on="on"
          >
            <span v-if="hightlightText.start" class="font-size-14">{{ hightlightText.start }}</span>
            <span v-if="hightlightText.hightlightText" class="hightlight-text font-size-14">{{ hightlightText.hightlightText }}</span>
            <span v-if="hightlightText.end" class="font-size-14">{{ hightlightText.end }}</span>
          </span>
        </template>
        <span class="font-size-14">{{ contentTypeProps.text }}</span>
      </v-tooltip>
    </v-col>
    <v-col v-if="isHorse" cols="4" class="text-center align-content-center">
      <!-- {{ minutesToHours(contentTypeDailyEffort) }} -->
      <v-row no-gutters>
        <v-col cols="4" class="light-pink-bg">
          {{ minutesToHours(contentTypeProps.dailyEffort) }}
        </v-col>
        <v-col cols="4" class="dark-pink-bg">
          {{ minutesToHours(contentTypeProps.weeklyEffort) }}
        </v-col>
        <v-col cols="4" class="heavy-pink-bg">
          {{ minutesToHours(contentTypeProps.monthlyEffort) }}
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { computed, inject } from '@vue/composition-api';
import { label, minutesToHours, sendNotification } from '@/helpers/utils';
import { getContractWithStock } from '@/helpers/request';
import { dragStart, dragLeave, dragOver, handleDrop } from '@/helpers/dragAndDrop';

import store from '@/store';
import router from '@/router';

export default {
  props: {
    contentType: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  setup (props) {
    const selectParticipantModalData = inject('selectParticipantModalData');
    const showParticipantModal = inject('showParticipantModal');

    const search = computed(() => store.state.search);

    const isHorse = computed(() => props.contentType.wtype === 'horse');

    const cols = computed(() => (isHorse.value ? 'flex-auto' : 'col-6'));

    const contentTypeProps = computed(() => {
      switch (props.contentType.wtype) {
        case 'customer': {
          return {
            text: `${props.contentType.fullname}`,
            icon: 'mdi-account'
          };
        }
        case 'collaborator':
          return {
            text: `${props.contentType.fullname}`,
            icon: 'mdi-account'
          };

        case 'horse':
          return {
            text: `${props.contentType.wtitle}`,
            icon: null,
            dailyEffort: props.contentType.dailyEffort,
            weeklyEffort: props.contentType.weeklyEffort,
            monthlyEffort: props.contentType.monthlyEffort
          };

        default:
          return {
            text: `${props.contentType.wtitle}`,
            icon: null
          };
      }
    });

    const hightlightText = computed(() => {
      const text = label(contentTypeProps.value.text, 20);

      if (props.contentType.wtype === 'customer') {
        return {
          start: text,
          hightlightText: null,
          end: null
        };
      }

      const hightlightTextIndex = contentTypeProps.value.text.toLowerCase().indexOf(search.value.toLowerCase());

      if (hightlightTextIndex !== -1) {
        const textToHighlight = text.slice(hightlightTextIndex, hightlightTextIndex + search.value.length);
        const startIndex = text.indexOf(textToHighlight);
        const start = text.slice(0, startIndex);
        const completedWord = `${start}${textToHighlight}`;
        const end = text.slice(completedWord.length, text.length);
        return {
          start,
          hightlightText: textToHighlight,
          end
        };
      }
      return text;
    });

    const openResoursePage = async contentType => {
      const { uuid } = contentType;
      if (contentType.wtype === 'customer') {
        if (contentType.firstname.includes('Inconnue')) {
          sendNotification('error', 'Le client est inconnu');
          return;
        }

        if (!uuid) {
          if (!uuid) {
            sendNotification('error', 'client introuvable');
            return;
          }
        }
      }

      router.push({
        name: 'ResourcePage',
        params: {
          type: contentType.wtype,
          uuid: uuid
        }
      });
    };

    const dropItem = async (event, contentType) => {
      const { isCustomerCase, customer_uuid, session, customer } = handleDrop(event, contentType);

      const uuid = customer_uuid;

      if (isCustomerCase) {
        if (!uuid) {
          sendNotification('error', 'client introuvable');
          return;
        }

        if (session.participants.find(participant => participant.uuid === customer.uuid)) {
          sendNotification('error', 'Le client existe déjà sur la session');
          return;
        }
        const text = 'Obtenir des contrats clients ...';
        sendNotification('info', text);
        const contractsWhithStock = await getContractWithStock(uuid);
        selectParticipantModalData.value = { contracts: contractsWhithStock.data, user: customer, session: session };
        showParticipantModal.value = true;
      }
    };

    return { cols, minutesToHours, isHorse, label, contentTypeProps, hightlightText, search, dragStart, dropItem, dragLeave, dragOver, openResoursePage };
  }
};
</script>

<style scoped>
  .contentTypeList:hover{
    background-color: rgb(199, 25, 0, 0.05);
  }
</style>
